module.exports = __webpack_public_path__ + "static/media/03.a8555606.webp";